import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IError } from '../../../../httpClient/serverApi/types/IError';

export interface ISetUsersAdminProfileParams {
  userLuids: string[];
  adminProfileLuid?: string;
}

/** Matches server BatchedUserIdActionResultViewModel: errors and results per user LUID. */
export interface ISetUsersAdminProfileResult {
  errors?: IError[];
  results?: Array<{ id: string, codes: number[] }>;
}

export class SetUsersAdminProfileRequest extends Request<ISetUsersAdminProfileParams, ISetUsersAdminProfileResult> {
  constructor(params: ISetUsersAdminProfileParams) {
    super('setUsersAdminProfile', params);
  }
}
